(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-section-type-attribute', {
            parent: 'entity',
            url: '/custom-section-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customSectionTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attributes.html',
                    controller: 'CustomSectionTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customSectionTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-section-type-attribute-detail', {
            parent: 'custom-section-type-attribute',
            url: '/custom-section-type-attribute/{id}',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customSectionTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-detail.html',
                    controller: 'CustomSectionTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customSectionTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomSectionTypeAttribute', function($stateParams, CustomSectionTypeAttribute) {
                    return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-section-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-section-type-attribute-detail.edit', {
            parent: 'custom-section-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomSectionTypeAttribute', function(CustomSectionTypeAttribute) {
                            return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-section-type-attribute.new', {
            parent: 'custom-section-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-section-type-attribute', null, { reload: 'custom-section-type-attribute' });
                }, function() {
                    $state.go('custom-section-type-attribute');
                });
            }]
        })*/
        
        .state('custom-section-type-attribute.new', {
			parent : 'custom-section-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-section-type-attribute.edit', {
            parent: 'custom-section-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomSectionTypeAttribute', function(CustomSectionTypeAttribute) {
                            return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-section-type-attribute', null, { reload: 'custom-section-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-section-type-attribute.edit', {
			parent : 'custom-section-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ],
				pageTitle : 'trakeyeApp.customSectionTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customSectionTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomSectionTypeAttribute', function($stateParams, CustomSectionTypeAttribute) {
					return CustomSectionTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-section-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-section-type-attribute.delete', {
            parent: 'custom-section-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-delete-dialog.html',
                    controller: 'CustomSectionTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomSectionTypeAttribute', function(CustomSectionTypeAttribute) {
                            return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-section-type-attribute', null, { reload: 'custom-section-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-section-type-attribute', {
            parent: 'entity',
            url: '/custom-section-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customSectionTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attributes.html',
                    controller: 'CustomSectionTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customSectionTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-section-type-attribute-detail', {
            parent: 'custom-section-type-attribute',
            url: '/custom-section-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customSectionTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-detail.html',
                    controller: 'CustomSectionTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customSectionTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomSectionTypeAttribute', function($stateParams, CustomSectionTypeAttribute) {
                    return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-section-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-section-type-attribute-detail.edit', {
            parent: 'custom-section-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomSectionTypeAttribute', function(CustomSectionTypeAttribute) {
                            return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-section-type-attribute.new', {
            parent: 'custom-section-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-section-type-attribute', null, { reload: 'custom-section-type-attribute' });
                }, function() {
                    $state.go('custom-section-type-attribute');
                });
            }]
        })
        .state('custom-section-type-attribute.edit', {
            parent: 'custom-section-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomSectionTypeAttribute', function(CustomSectionTypeAttribute) {
                            return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-section-type-attribute', null, { reload: 'custom-section-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-section-type-attribute.delete', {
            parent: 'custom-section-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-delete-dialog.html',
                    controller: 'CustomSectionTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomSectionTypeAttribute', function(CustomSectionTypeAttribute) {
                            return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-section-type-attribute', null, { reload: 'custom-section-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/
